import { render, staticRenderFns } from "./modalRejetarComissao.vue?vue&type=template&id=3a878780&scoped=true"
import script from "./modalRejetarComissao.vue?vue&type=script&lang=js"
export * from "./modalRejetarComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a878780",
  null
  
)

export default component.exports